import { render, staticRenderFns } from "./ObjectsRemovePopUp.vue?vue&type=template&id=4915befa&scoped=true&"
import script from "./ObjectsRemovePopUp.vue?vue&type=script&lang=js&"
export * from "./ObjectsRemovePopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4915befa",
  null
  
)

export default component.exports